export function findModuleDetailForId(id, modulesDetails) {
    return modulesDetails.find(moduleDetails => moduleDetails.id === id);
}

/** @returns {Set<number>} */
export function getAllShadeIdForModuleElements(modules) {
    const res = new Set();
    for (const module of modules) {
        for (const shadeId of Object.values(module.spec.shadeByGroup)) {
            res.add(shadeId);
        }
    }
    return res;
}

/** @returns {Set<number>} */
export function getAllModuleIdFromModuleElements(elements) {
    const res = new Set();
    for (const element of elements) {
        Number.isInteger(element.model.id) && res.add(element.model.id);
    }
    return res;
}

/**
 * Applique le status récupéré de l'API à un ModuleElement pris du planogramme
 * @param moduleElement
 * @param moduleDetails
 */
function applyStatusToModule(moduleElement, moduleDetails) {
    if (moduleDetails.status) {
        moduleElement.status = moduleDetails.status;
        /*
         * Note : Status icon (new, inprogres...) are actually hard coded in the assets.icon's list.
         */
        moduleElement.addDecoration(assets.icons.status[moduleDetails.status.name], 3);
    }
}

/**
 * @param moduleElements
 * @param modulesDetails
 * @param shades
 * @returns {Promise<void>}
 */
export async function applyDetailsToModuleElements(moduleElements, modulesDetails, shades) {
    const rasterisePromises = [];
    for (const moduleElement of moduleElements) {
        const moduleDetails = findModuleDetailForId(moduleElement.modelId(), modulesDetails);
        if (!moduleDetails) {
            moduleElement.addDecoration(assets.icons.moduleCorrupted, 3);
            continue;
        }
        // Apply shades to moduleElement
        if (moduleElement.svg) {
            rasterisePromises.push(moduleElement.rasterisePreview(moduleDetails.config.groups, [{ shades }]));
        }
        //Apply status from moduleDetails
        applyStatusToModule(moduleElement, moduleDetails);
    }
    await Promise.all(rasterisePromises);
}



// WEBPACK FOOTER //
// ./src/plano/utils/shades-utils.js